<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { OP_TABLE_CTX, type OpTableContext, type SortDir, type ColumnMeta } from './opTable.context';

@Options({
  provide() {
    const self = this as any;
    const ctx: OpTableContext = {
      getFilterValue: (key) => self.uiFilterShadow[key], // shadow per ripopolare gli input
      setFilterValue: (key, value, meta?: ColumnMeta) => {
        self.uiFilterShadow[key] = value;

        if (!meta) meta = {};
        // mappatura su this.filter come facevi prima
        if (meta.filterType === 'dateRange') {
          self.filter[meta.fromKey!] = value?.from ? new Date(value.from).toISOString() : null;
          self.filter[meta.toKey!]   = value?.to   ? new Date(value.to).toISOString()   : null;
        } else if (meta.filterType === 'numberRange') {
          self.filter[meta.fromKey!] = value?.from ?? null;
          self.filter[meta.toKey!]   = value?.to   ?? null;
        } else if (meta.filterType === 'checkbox') {
          // 0 ignore -> unset, 1 -> false, 2 -> true
          if (value === 0 || value === '0') delete self.filter[meta.key!];
          else if (value === 1 || value === '1') self.filter[meta.key!] = false;
          else if (value === 2 || value === '2') self.filter[meta.key!] = true;
        } else {
          self.filter[meta.key!] = value ?? '';
        }
        self.emitSearch();
      },
      getSort: () => {
        const sb = (self.filter && self.filter.sortBy) || null;
        return { key: sb?.propertyName, dir: sb ? (sb.ascending ? 'asc' : 'desc') : '' };
      },
      setSort: (key?: string, dir: SortDir = '') => {
        if (!key || !dir) {
          self.filter.sortBy = null;
        } else {
          self.filter.sortBy = { propertyName: key, ascending: dir === 'asc' };
        }
        self.emitSearch();
      }
    };
    return { [OP_TABLE_CTX as any]: ctx };
  }
})
export default class OpTableServerSide extends Vue {
  @Prop({ default: () => [] }) items!: any[];
  @Prop({ default: true }) showUpperPagination!: boolean;
  @Prop({ default: true }) showLowerPagination!: boolean;
  @Prop({ default: 10 }) itemsPerPage!: number;
  @Prop({ default: () => ({}) }) filter!: any;
  @Prop({ default: 0, required: true }) totalItemsCount!: number;

  // ometto: template/pagination sono gli stessi tuoi attuali
  selectedPage = 1; xItemsPerPage = 10; pages:number[] = []; totalPages=0; lowerPages=0; upperPages=0;

  // shadow per ripopolare input header
  uiFilterShadow: Record<string, any> = {};

  created(){ this.xItemsPerPage = this.itemsPerPage; }
  mounted(){ this.calcPagination(); }
  @Watch('xItemsPerPage') onIPP(){ this.calcPagination(); }
  @Watch('totalItemsCount') onCount(){ this.calcPagination(); }

  @Watch('filter', { deep: true }) onFilterChange(){ this.$emit('search', this.filter); }

  emitSearch(){
    this.filter.pageNumber = this.selectedPage;
    this.filter.perPage = this.xItemsPerPage;
    this.$emit('search', this.filter);
  }

  setSelectedPage(i:number){ this.selectedPage = i; this.calcPagination(); this.emitSearch(); }
  subtractPage(){ if(this.selectedPage>1){ this.selectedPage--; this.calcPagination(); this.emitSearch(); } }
  addPage(){ if(this.selectedPage<this.totalPages){ this.selectedPage++; this.calcPagination(); this.emitSearch(); } }

  calcPagination(){
    this.totalPages = Math.ceil((this.totalItemsCount) / this.xItemsPerPage) || 1;
    if(this.selectedPage > this.totalPages && this.selectedPage > 1) this.selectedPage = this.totalPages;
    this.lowerPages = this.selectedPage - 2;
    this.upperPages = this.selectedPage + 2;
    if(this.selectedPage == 1) this.upperPages += 2; else if(this.selectedPage == 2) this.upperPages += 1;
    if(this.selectedPage == this.totalPages) this.lowerPages -= 2; else if(this.selectedPage == this.totalPages - 1) this.lowerPages -= 1;
    if(this.upperPages > this.totalPages) this.upperPages = this.totalPages;
    if(this.lowerPages <= 0) this.lowerPages = 1;
    this.pages = []; for(let i=this.lowerPages; i<=this.upperPages; i++) this.pages.push(i);
  }
}
</script>
